import React from 'react'
import cx from 'classnames'
import { useParticipantNetworkQualityLevel } from '@gopeerproject/web-kit'

const LEVELS = [1, 2, 3, 4, 5]

const NetworkQualityLevel = ({ participant }) => {
  const networkQualityLevel = useParticipantNetworkQualityLevel(participant)

  if (networkQualityLevel === null) return null

  return (
    <div
      className={cx('gp-NetworkQualityLevel', {
        'is-unstable': networkQualityLevel <= 2
      })}
    >
      <div className='gp-NetworkQualityLevel-bars'>
        {LEVELS.map((v) => (
          <div
            key={v}
            style={{ height: v * 2 }}
            className={cx('gp-NetworkQualityLevel-bar', {
              'is-active': v <= networkQualityLevel
            })}
          />
        ))}
      </div>
    </div>
  )
}

export default NetworkQualityLevel
